import React, { ReactElement } from 'react'
import { Modal, ModalDialog, ModalDisclosure } from '@woorcs/design-system'

import { ManageResponseSets } from './ManageResponseSets'

type ManageResponseSetsProps = {
  children: ReactElement
}

export const ManageResponseSetsModal = ({
  children
}: ManageResponseSetsProps) => (
  <Modal>
    <ModalDisclosure>{children}</ModalDisclosure>
    <ModalDialog width={540} px={5} py={8}>
      <ManageResponseSets />
    </ModalDialog>
  </Modal>
)
